interface PrimaryVariantProps {
  variant?: 'primary';
  badge?: string;
  title?: string;
  description?: string;
  progress?: {
    current: number;
    total: number;
    type?: 'percentage' | 'steps';
  } | null;
  buttonText?: string;
  onPress?: () => void;
  onPressInfo: () => void;
  image?: string;
}

interface SecondaryVariantProps {
  variant: 'secondary';
  image: string;
  title: string;
  buttonText: string;
  onPress: () => void;
  onPressInfo: () => void;
}

export type ChallengeHomeCardProps = PrimaryVariantProps | SecondaryVariantProps;
